export default __webpack_public_path__ + "static/media/LearningHowToLearn.bd7c53e0.JPG";